import { User } from "../models/user";
import { ConflictError, UnauthorizedError } from "../errors/http_errors";


async function fetchData(input: RequestInfo, init?: RequestInit) {
    const response = await fetch(input, init);
    if (response.ok) {
        return response;
    } else {
        const errorBody = await response.json();
        const errorMessage = errorBody.error;
        if (response.status === 401) {
            throw new UnauthorizedError(errorMessage);
        } else if (response.status === 409) {
            throw new ConflictError(errorMessage);
        } else {
            throw Error("Request failed with status: " + response.status + " message: " + errorMessage);
        }
    }
};

export interface LoginCredentials {
    username: string,
    password: string,
};

export interface UserProps {
        userId: string,
        username: string,
        password: string,
        firstname: string,
        lastname: string
}

export async function getLoggedInUser(): Promise<User> {
    const response = await fetchData("/api/users", { method: "GET" });
    return response.json();
}

export async function login(credentials: LoginCredentials): Promise<User> {
    const response = await fetchData("/api/users/login",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(credentials),
        });
    return response.json();
};

export async function logout() {
    await fetchData("/api/users/logout", { method: "POST" });
};

export async function register(newUser: UserProps): Promise<UserProps> {
    const response = await fetchData("/api/users/registeruser",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(newUser),
        });
    return response.json();
}

export async function remove(User: UserProps) {
    const response = await fetchData("/api/users/removeuser",
        {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(User),
        });
    return response.json();
}